import type { SessionsOpportunity } from '@carboncopyco/data';
import { TextBase, TooltipBubble } from '@carboncopyco/ui';
import { MMMDoYYYYhmma, getCalendarDate } from '@carboncopyco/utils';
import type { Col } from '../../../../FixedTable';

export const getCols = (isInModal?: boolean): Col<SessionsOpportunity>[] => [
  {
    alignment: 'left',
    title: 'Name',
    width: isInModal ? 650 : 180,
    maxContentWidth: isInModal ? 620 : 150,

    render: (opportunity) => (
      <TooltipBubble
        placement="top-start"
        title={opportunity.name}
      >
        <div className="truncate">
          <TextBase
            label={opportunity.name}
            color="text-ds-natural-600"
            ellipsis
          />
        </div>
      </TooltipBubble>
    ),
  },
  {
    alignment: 'left',
    title: 'Last interaction',
    width: isInModal ? 250 : 170,
    maxContentWidth: isInModal ? 250 : 150,
    render: (opportunity) => (
      <TooltipBubble
        placement="top-start"
        title={MMMDoYYYYhmma(opportunity.lastInteraction)}
      >
        <div className="truncate">
          <TextBase
            label={getCalendarDate(opportunity.lastInteraction)}
            color="text-ds-natural-600"
            ellipsis
          />
        </div>
      </TooltipBubble>
    ),
  },
];
